module.exports = __webpack_public_path__ + "media/feature-icons/Dispatch-ed88add6.svg";